import React, { useEffect } from "react";
import { Column, Columns, Stack } from "@origin-digital/ods-core";
import AutocompleteField from "./AutocompleteField";
import HelperText from "./HelperText";
import { Field, useFormikContext } from "formik";
import FormContext from "src/context/FormContext";
import { ElectricityBlockValues } from "../types";
import ContactFieldASP from "./ContactFieldASP";
import HomeUserAspBlock from "../HomeUser/HomeUserAspBlock";

interface IMeterProviderProps {
  hasCes: boolean;
  homeUser: boolean;
}

export const mapMeterProviderValueToLabel: { [key: string]: string } = {
  origin: "Origin",
  ACUMENMPB: "Intellihub",
  TCAMPMPB: "Plus ES",
  VECTORMP: "BlueCurrent",
};

const getMeterProviderOptions = (state: string) => {
  if (state === "ACT" || state === "NSW" || state === "QLD") {
    return [
      { label: "Origin", value: "origin" },
      { label: "Intellihub", value: "ACUMENMPB" },
      { label: "Plus ES", value: "TCAMPMPB" },
      { label: "BlueCurrent", value: "VECTORMP" },
    ];
  }
  if (state === "SA") {
    return [
      { label: "Origin", value: "origin" },
      { label: "Intellihub", value: "ACUMENMPB" },
      { label: "BlueCurrent", value: "VECTORMP" },
    ];
  }
  return [];
};

const MeterProvider: React.FC<IMeterProviderProps> = ({ hasCes, homeUser }) => {
  const {
    formState: { state },
  } = React.useContext(FormContext);

  const { values, setFieldValue } = useFormikContext<ElectricityBlockValues>();

  const meterProviderOptions = getMeterProviderOptions(state);

  const showHelperText = state === "NSW";

  useEffect(() => {
    const showAsp =
      state === "NSW" &&
      (values.meterProvider === "TCAMPMPB" ||
        values.meterProvider === "ACUMENMPB") &&
      !hasCes;

    setFieldValue("showAsp", showAsp);
  }, [state, values.meterProvider, hasCes, setFieldValue]);

  return (
    <Columns
      collapseBelow="md"
      space={{ xs: "none", md: "xlarge" }}
      alignY="stretch"
    >
      <Column width="2/3">
        <Stack space={{ xs: "xlarge", md: "xxlarge" }}>
          <Field
            component={AutocompleteField}
            name="meterProvider"
            label="Meter provider"
            options={meterProviderOptions}
          />
          {values.showAsp &&
            (homeUser ? (
              <HomeUserAspBlock meterProvider={values.meterProvider} />
            ) : (
              <ContactFieldASP
                name="asp"
                label="Accredited service provider (ASP)"
                contactType="SERVICE_PROVIDER"
              />
            ))}
        </Stack>
      </Column>
      {showHelperText ? (
        <Column width="1/3">
          <HelperText text="To be allowed to complete the works on site, an electrician must be accredited by this meter provider." />
        </Column>
      ) : null}
    </Columns>
  );
};

export default MeterProvider;
